// PR-A (GĐ2 audit) — Reduced-runtime embed.
// ?embed=1 (iframe share ngoài /watch/self, legal modal /terms) → tắt
// analytics (GA/PostHog/Sentry), auth bootstrap, visitor tracker, WS hub.
// Iframe chỉ còn player + API tối thiểu → chặn fan-out về origin.
export function isEmbedRuntime() {
  try {
    return new URLSearchParams(window.location.search).get("embed") === "1";
  } catch {
    return false;
  }
}
